import React, { useEffect, useState, useMemo } from 'react';
import { MapProps, BuoyProps } from '../../../../types';
import { useFetchData } from '../../../../hooks/useFetchData';
import config from '../../../../config';
import { AdvancedMarker, Map as MapGoogle } from '@vis.gl/react-google-maps';
import './Map.css';

const CustomMap: React.FC<MapProps> = ({ callBuoy, setBuoysLoadMap }) => {
  const { apiUrl, website: configWebsite } = config;

  const { data, error, loading } = useFetchData(apiUrl);
  const [buoys, setBuoys] = useState<BuoyProps[]>([]);

  const [mapRef, setMapRef] = useState<google.maps.Map | null>(null);
  const MAX_ZOOM_LEVEL: number = 6;
  const [zoomMap, setZoomMap] = useState<number>(2);
  const [autoZoomMap, setAutoZoomMap] = useState<boolean>(false);
  const [mapCenter, setMapCenter] = useState<google.maps.LatLngLiteral>({
    lat: 0,
    lng: 0,
  });

  const targetWebsite = useMemo(() => {
    return configWebsite.toLowerCase();
  }, [configWebsite]);

  const filteredBuoys = useMemo(() => {
    const filtered = buoys.filter(
      (buoy) => buoy.website.toLowerCase() === targetWebsite,
    );

    return filtered;
  }, [buoys, targetWebsite]);

  const fitBounds = () => {
    if (!mapRef || !filteredBuoys.length) {
      return;
    }
    setAutoZoomMap(true);
    const bounds = new window.google.maps.LatLngBounds();
    filteredBuoys.forEach(({ lat, longi }) => {
      bounds.extend(new window.google.maps.LatLng(lat, longi));
    });
    mapRef.fitBounds(bounds);
  };

  const changeCenter = (lat: number, lng: number) => {
    if (!mapRef) {
      return;
    }
    mapRef.setCenter({ lat, lng });
  };

  useEffect(() => {
    if (data && !loading) {
      data.forEach((buoy: BuoyProps) => {});
      setBuoys(data);
      setBuoysLoadMap(true);
    }
  }, [data, loading, setBuoysLoadMap]);

  useEffect(() => {
    fitBounds();
  }, [filteredBuoys, mapRef]);

  useEffect(() => {
    if (autoZoomMap) {
      setAutoZoomMap(false);
      if (filteredBuoys.length === 1) {
        mapRef?.setZoom(MAX_ZOOM_LEVEL);
      } else {
        if (zoomMap > MAX_ZOOM_LEVEL) {
          mapRef?.setZoom(MAX_ZOOM_LEVEL);
        } else {
        }
      }
    } else {
    }
  }, [zoomMap, autoZoomMap, filteredBuoys.length, targetWebsite, mapRef]);

  useEffect(() => {
    if (filteredBuoys.length > 0) {
      setMapCenter({ lat: filteredBuoys[0].lat, lng: filteredBuoys[0].longi });
    }
  }, [filteredBuoys]);

  if (loading) {
    return <div className="loader"></div>;
  }

  if (error) {
    return <div>Error loading map: {error.message}</div>;
  }

  return (
    <MapGoogle
      defaultZoom={6}
      center={mapCenter}
      mapId="eolos_map_id"
      mapTypeId="satellite"
      streetViewControl={false}
      mapTypeControl={false}
      zoomControl={true}
      fullscreenControl={false}
      onZoomChanged={() => {
        const newZoom = mapRef?.getZoom() ?? 0;

        setZoomMap(newZoom);
      }}
    >
      {filteredBuoys.map((buoy: BuoyProps) => {
        return (
          <AdvancedMarker
            key={`MarkerBuoy_${buoy.id_buoy}`}
            position={{ lat: buoy.lat, lng: buoy.longi }}
            title={buoy.name_buoy}
            onClick={() => {
              callBuoy(buoy.id_buoy.toString(), buoy.name_buoy, buoy.utc);
              changeCenter(buoy.lat, buoy.longi);
            }}
          >
            <img
              src="assets/img/icon-pointer.png"
              width={46}
              height={51}
              alt={`${buoy.name_buoy} Marker`}
            />
          </AdvancedMarker>
        );
      })}
    </MapGoogle>
  );
};

export default CustomMap;
